import React from "react";
import { Icon, Typography } from "@mui/material";

import RpMuiToolTip from "@/components/muiCustom/popover/RpMuiToolTip";
import RpSvgIcon from "@/components/icons/RpSvgIcon";

const headerTooltipContent = {
  Location:
    "These are your locations that have active advertising and are eligible to be adjusted. If you don't see a location, it may not be eligible based on campaign timing or other factors.",
  Type: "These are the channels your ads are appearing on. To adjust only one channel, select the channel here. Otherwise, adjusting all channels will optimize results.",
  "Boost Start Date":
    "This is the date you want to start spending more money on advertising.",
  "Boost End Date":
    "This is the date you want to end your adjustment, and spend will reduce back to the original amount.",
  "Current budget for the selected dates":
    "Based on the dates you've selected, this is the current budget for that time period. This allows you to see what you are spending without adjusting.",
  "Add Boost Budget":
    "This is the amount of additional money you want to spend, above your current budget, between the start and end dates you've selected.",
};

function BoostHeaderTooltip({ label = "" }) {
  return (
    <span className="d-inline-block">
      <RpMuiToolTip
        content={
          <Typography component="p" variant="caption" className="fs-10">
            {headerTooltipContent[label]}
          </Typography>
        }
      >
        <span className="d-inline-block">
          <Icon
            component={RpSvgIcon}
            name="green_info"
            fontSize="small"
            color="primary"
            style={{ width: 15, height: 15 }}
            className="ml-1 cursor-p"
          />
        </span>
      </RpMuiToolTip>
    </span>
  );
}

export default BoostHeaderTooltip;
